import React, { useState, useEffect } from 'react';
import { Button, SCIcon } from './Imports';
import { IsError } from './Utility/IsError';

interface ButtonProp {
    Name: string;
    Label?: string;
    IconFilled?: boolean;
    OnClick?: () => void;
    Classes?: string;
    Type?: "button" | "submit" | "reset";
}

interface ButtonsData {
    [key: string]: {
        severity: 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help' | undefined,
        icon: string,
    };
}

export const SCButton: React.FC<ButtonProp> = ({ Name, Label, OnClick, IconFilled = false, Classes = "", Type="button" }) => {
    const [Buttons, setButtons] = useState<ButtonsData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchButtons = async () => {
            try {
                const response = await fetch('/Buttons.json');
                if (!response.ok) {
                    throw new Error(`Failed to fetch icons: ${response.statusText}`);
                }
                const data: ButtonsData = await response.json();
                setButtons(data);
            } catch (err) {
                if (IsError(err)) {
                    setError(err.message);
                } else {
                    setError('An unknown error occurred');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchButtons();
    }, []);

    if (loading) return <span>Loading...</span>;
    if (error) return <span>Error: {error}</span>;

    const ButtonData = Buttons?.[Name] || { severity: undefined, icon: 'MenuItemNoIcon' };

    return (
        <Button
            type={Type}
            label={Label}
            severity={ButtonData.severity || undefined}
            icon={<SCIcon Name={ButtonData.icon} Filled={IconFilled} />}
            onClick={OnClick}
            className={`ps-1 ${Classes}`}
        />
    );
};

export default SCButton;
